import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';

export const roleGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const response = authService.isLoggedInToRedirect(route);
  return response?.isLoggedIn ? true : router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
};
